import React from "react";
import { Col, Space } from "antd";

import * as String from "../../commons/string";
import EventUserList from "../../components/EventUserList";
import EventPrizeList from "../../components/EventPrizeList";

function Campingfair2024() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">{String.titleCampingfair2024}</h3>
                <EventUserList eventId={6} />
                <EventPrizeList eventId={6} />
            </Space>
        </div>
    );
}

export default Campingfair2024;
